import React, { useEffect, useState, useRef } from 'react';
import { CameraIcon, FilmIcon, MapPinIcon, UsersIcon } from 'lucide-react';
export const AboutSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.disconnect();
      }
    };
  }, []);
  return <section id="about" ref={sectionRef} className="py-24 bg-gray-950 w-full relative overflow-hidden" data-id="element-24">
      <div className="absolute inset-0 overflow-hidden" data-id="element-25">
        <div className="absolute -top-20 -right-20 w-96 h-96 rounded-full bg-blue-900/10 blur-3xl" data-id="element-26"></div>
        <div className="absolute top-1/3 -left-20 w-80 h-80 rounded-full bg-blue-700/5 blur-3xl" data-id="element-27"></div>
        <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] rounded-full bg-blue-800/5 blur-3xl" data-id="element-28"></div>
        <div className="absolute -left-20 top-1/4 w-[150px] h-[800px] bg-gradient-to-b from-black via-blue-900/20 to-black transform rotate-45 opacity-20" data-id="element-29"></div>
        <div className="absolute -right-20 bottom-1/4 w-[150px] h-[800px] bg-gradient-to-b from-black via-blue-900/20 to-black transform -rotate-45 opacity-20" data-id="element-30"></div>
      </div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-31">
        <div className="max-w-5xl mx-auto" data-id="element-32">
          <div className="text-center mb-12" data-id="element-33">
            <div className={`inline-block p-1.5 px-3 bg-blue-900/20 border border-blue-800/30 rounded-full mb-4 backdrop-blur-sm transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'}`} data-id="element-34">
              <span className="text-blue-400 text-sm font-medium" data-id="element-35">
                Professionele Producties
              </span>
            </div>
            <h2 className={`text-3xl md:text-5xl font-bold mb-6 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-36">
              Over <span className="text-blue-400" data-id="element-37">Blue Rain</span> Productions
            </h2>
            <p className={`text-lg text-gray-400 max-w-3xl mx-auto transition-all duration-700 delay-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-38">
              Met jarenlange ervaring in de film- en tv-industrie brengen wij uw
              project tot leven met creativiteit, expertise en toewijding.
            </p>
          </div>
          <div className={`grid grid-cols-1 md:grid-cols-2 gap-12 transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-39">
            <div className="relative" data-id="element-40">
              <div className="relative z-10 overflow-hidden rounded-md shadow-xl" data-id="element-41">
                <div className="relative w-full aspect-[3/4] overflow-hidden" data-id="element-42">
                  <div className="absolute inset-0 transition-opacity duration-1000 ease-in-out" id="ownerImage1" style={{
                  backgroundImage: `url('https://uploadthingy.s3.us-west-1.amazonaws.com/4p5A8nqJmZCAnkdbSc3Tyy/37532d94-3195-4409-83b1-fb33f87929d4.jpg')`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  opacity: 1
                }} role="img" aria-label="Martijn Mantel - Oprichter Blue Rain Productions" data-id="element-43"></div>
                  <div className="absolute inset-0 transition-opacity duration-1000 ease-in-out" id="ownerImage2" style={{
                  backgroundImage: `url('https://uploadthingy.s3.us-west-1.amazonaws.com/uUxyZLk2pbrDRbj6yKDhBC/ec30fd72-e718-489d-8465-0bf8c201e837.jpg')`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  opacity: 0
                }} role="img" aria-label="Martijn Mantel op de set - Oprichter Blue Rain Productions" data-id="element-44"></div>
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-950 via-gray-950/60 to-transparent z-10" onClick={() => {
                  const img1 = document.getElementById('ownerImage1');
                  const img2 = document.getElementById('ownerImage2');
                  if (img1 && img2) {
                    const img1Opacity = window.getComputedStyle(img1).opacity;
                    img1.style.opacity = img1Opacity === '1' ? '0' : '1';
                    img2.style.opacity = img1Opacity === '1' ? '1' : '0';
                  }
                }} data-id="element-45"></div>
                  <div className="absolute bottom-2 right-2 z-20 flex space-x-1" data-id="element-46">
                    <span className="w-2 h-2 rounded-full bg-blue-400 opacity-80 cursor-pointer hover:bg-blue-300" onClick={() => {
                    const img1 = document.getElementById('ownerImage1');
                    const img2 = document.getElementById('ownerImage2');
                    if (img1 && img2) {
                      img1.style.opacity = '1';
                      img2.style.opacity = '0';
                    }
                  }} data-id="element-47"></span>
                    <span className="w-2 h-2 rounded-full bg-gray-400 opacity-80 cursor-pointer hover:bg-blue-300" onClick={() => {
                    const img1 = document.getElementById('ownerImage1');
                    const img2 = document.getElementById('ownerImage2');
                    if (img1 && img2) {
                      img1.style.opacity = '0';
                      img2.style.opacity = '1';
                    }
                  }} data-id="element-48"></span>
                  </div>
                </div>
                <div className="absolute -bottom-4 -right-4 w-24 h-24 border-2 border-blue-600/30 rounded-md z-0" data-id="element-49"></div>
                <div className="absolute -top-4 -left-4 w-32 h-32 border-2 border-blue-600/20 rounded-md z-0" data-id="element-50"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 z-30" data-id="element-51">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-52">
                  Martijn Mantel
                </h3>
                <p className="text-blue-400 font-medium" data-id="element-53">Oprichter</p>
              </div>
            </div>
            <div className="space-y-6" data-id="element-54">
              <p className="text-lg text-gray-300 leading-relaxed" data-id="element-55">
                Hey! ik ben Martijn, de oprichter van Blue Rain Productions. Met
                jarenlange ervaring in de film- en tv-industrie weet ik precies
                wat nodig is om jouw project tot leven te brengen. Of je nu
                zoekt naar een producer, locatiemanager, setmanager of
                locatiescout, bij mij ben je aan het juiste adres voor
                professionele ondersteuning.
              </p>
              <p className="text-lg text-gray-300 leading-relaxed" data-id="element-56">
                Bovendien werk ik samen met een team van betrouwbare,
                gepassioneerde partners die net als ik streven naar kwaliteit.
                Samen zorgen we ervoor dat elk detail klopt, zodat jij het beste
                uit jouw project haalt.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8" data-id="element-57">
                <div className="bg-blue-900/10 border border-blue-900/20 backdrop-blur-sm p-4 rounded-md" data-id="element-58">
                  <FilmIcon className="text-blue-400 mb-3" size={24} data-id="element-59" />
                  <h4 className="font-semibold text-white text-lg mb-2" data-id="element-60">
                    Producer
                  </h4>
                  <p className="text-gray-400 text-sm" data-id="element-61">
                    Zorgt dat het project van begin tot eind soepel verloopt
                  </p>
                </div>
                <div className="bg-blue-900/10 border border-blue-900/20 backdrop-blur-sm p-4 rounded-md" data-id="element-62">
                  <MapPinIcon className="text-blue-400 mb-3" size={24} data-id="element-63" />
                  <h4 className="font-semibold text-white text-lg mb-2" data-id="element-64">
                    Locatiemanager
                  </h4>
                  <p className="text-gray-400 text-sm" data-id="element-65">
                    Verzorgt locaties die aansluiten op jouw visie
                  </p>
                </div>
                <div className="bg-blue-900/10 border border-blue-900/20 backdrop-blur-sm p-4 rounded-md" data-id="element-66">
                  <UsersIcon className="text-blue-400 mb-3" size={24} data-id="element-67" />
                  <h4 className="font-semibold text-white text-lg mb-2" data-id="element-68">
                    Setmanager
                  </h4>
                  <p className="text-gray-400 text-sm" data-id="element-69">
                    Houdt alles op de set perfect in de gaten
                  </p>
                </div>
                <div className="bg-blue-900/10 border border-blue-900/20 backdrop-blur-sm p-4 rounded-md" data-id="element-70">
                  <CameraIcon className="text-blue-400 mb-3" size={24} data-id="element-71" />
                  <h4 className="font-semibold text-white text-lg mb-2" data-id="element-72">
                    Locatiescout
                  </h4>
                  <p className="text-gray-400 text-sm" data-id="element-73">
                    Vindt de perfecte locaties voor jouw project
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className={`mt-16 p-6 bg-gradient-to-r from-blue-900/20 to-transparent border-l-4 border-blue-500 rounded-r-md transition-all duration-1000 delay-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-74">
            <p className="text-lg text-gray-300 leading-relaxed italic" data-id="element-75">
              "Bij Blue Rain Productions draait het om kwaliteit,
              betrouwbaarheid en vooral goede vibes. Of je nu aan een film of
              tv-opname werkt, of juist een next-level videoclip of commercial
              nodig hebt, we got you! Klaar om iets vets neer te zetten? Hit me
              up!"
            </p>
          </div>
          <div className={`mt-12 flex justify-center transition-all duration-1000 delay-600 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-76">
            <a href="#contact" className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-sm transition-colors duration-300 flex items-center" data-id="element-77">
              Neem contact op
              <svg className="ml-2 w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-78">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-79" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>;
};